export default __webpack_public_path__ + "static/media/Manbir_Kaur_AHV_In_Moms_We_Trust.5042c73f.jpg";